// @flow

import {
  type UserInputValidationError,
  type UserInputValidatorArgs,
  onlyWhenSupport,
  VALID,
} from '@tectonics/prs/validation';

import { validatePeruvianCity } from './peruvian-city';
import { validatePeruvianState } from './peruvian-state';
import { validatePeruvianZipcode } from './peruvian-zipcode';
import { validatePeruvianAddress } from './peruvian-address';
import { validatePeruvianDocument } from './peruvian-document';
import { validatePeruvianPhoneNumber } from './peruvian-phone-number';
import { validatePeruvianStreetNumber } from './peruvian-street-number';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'peruvianDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_peruvian_document') && validatePeruvianDocument(userInputValue);
      }
      return null;

    case 'peruvianPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_peruvian_phone_number') && validatePeruvianPhoneNumber(userInputValue);
      }
      return null;

    case 'peruvianZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_peruvian_zipcode') && validatePeruvianZipcode(userInputValue);
      }
      return null;

    case 'peruvianState':
      if (!hasOptionalField(optionalFields, 'state')) {
        return onlyWhen('field_peruvian_state') && validatePeruvianState(userInputValue);
      }
      return null;

    case 'peruvianCity':
      if (!hasOptionalField(optionalFields, 'city')) {
        return onlyWhen('field_peruvian_city') && validatePeruvianCity(userInputValue);
      }
      return null;

    case 'peruvianAddress':
      if (!hasOptionalField(optionalFields, 'address')) {
        return onlyWhen('field_peruvian_address') && validatePeruvianAddress(userInputValue);
      }
      return null;

    case 'peruvianStreetNumber':
      if (!hasOptionalField(optionalFields, 'street_number')) {
        return onlyWhen('field_peruvian_street_number') && validatePeruvianStreetNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
